<div class="progress-container">
  <p-progressBar [value]="value"></p-progressBar>
  <ng-content></ng-content>
</div>
